export const HOME_COUNTRY_CODE = 'BY';
export const placeLabel = (p) => {
    if (p.city === null)
        return null;
    if (p.cityCountry === null || p.cityCountry === HOME_COUNTRY_CODE)
        return p.city;
    return `${p.city}, ${p.cityCountryName ?? p.cityCountry}`;
};
/**
 * AUT-761 — the country fields a snapshot (report brand, deal card) carries:
 * only for a city abroad. Belarus or no city → `{}`, so those snapshots stay
 * byte for byte what they were before AUT-761.
 */
export const placeAbroad = (p) => {
    if (p.city == null || p.cityCountry == null || p.cityCountry === HOME_COUNTRY_CODE)
        return {};
    return { cityCountry: p.cityCountry, cityCountryName: p.cityCountryName ?? null };
};
//# sourceMappingURL=place-label.js.map